import { useProjectList } from '../lib/projectList';
import { getTrackingSessionId, trackEvent } from '../lib/tracking';

const WHATSAPP_PHONE = '525549332582';

export function WhatsAppFloat() {
  const { count } = useProjectList();
  const leadRef = getTrackingSessionId();
  // Si la lista de proyecto está activa con items, ocultamos el WhatsApp solo
  // (el panel ya tiene su propio CTA de enviar al agente).
  if (count > 0) return null;
  return (
    <a
      href={`https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(`Hola NULED, tengo una duda\n\n_Referencia web: ${leadRef}_`)}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chatear por WhatsApp"
      onClick={() => trackEvent('click_whatsapp', { source: 'float_button' })}
      style={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: 90,
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: '#25D366',
        boxShadow: '0 6px 20px rgba(37,211,102,0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
      }}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
        <path d="M17.6 14.6c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7 0-.3-.2-1.2-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.6.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.4z" />
        <path d="M20.5 3.5C18.3 1.2 15.3 0 12 0 5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6c1.7.9 3.7 1.4 5.7 1.4h.1c6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.3zM12 21.6c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.7 1 1-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.2C2 6.6 6.5 2 12 2c2.7 0 5.2 1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1.1 5.4-4.4 9.6-10 9.6z" />
      </svg>
    </a>
  );
}
